import React from "react";
import {
  Box,
  Typography,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Skeleton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";

export default function MeterHistoryDrawer({
  open,
  onClose,
  historyMeter,
  meterHistory,
  loadingHistory,
}) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 400, p: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Meter Installation History
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {historyMeter && (
          <>
            <Box
              sx={{
                mb: 2,
                p: 2,
                backgroundColor: "grey.50",
                borderRadius: 1,
              }}
            >
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>Meter ID:</strong> {historyMeter.meter_id || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Serial Number:</strong>{" "}
                {historyMeter.meter_serial || "N/A"}
              </Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />
          </>
        )}
        {loadingHistory ? (
          <Box>
            {Array.from({ length: 3 }).map((_, index) => (
              <ListItem
                key={index}
                sx={{ flexDirection: "column", alignItems: "start", py: 2 }}
              >
                <Box sx={{ width: "100%" }}>
                  <Skeleton
                    variant="text"
                    width="70%"
                    height={24}
                    sx={{ mb: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="50%"
                    height={20}
                    sx={{ mb: 0.5 }}
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={20}
                    sx={{ mb: 0.5 }}
                  />
                  <Skeleton variant="text" width="40%" height={20} />
                </Box>
                <Divider sx={{ width: "100%", mt: 2 }} />
              </ListItem>
            ))}
          </Box>
        ) : (
          <List>
            {meterHistory?.map((record) => (
              <ListItem
                key={record.well_meter_ndx}
                sx={{ flexDirection: "column", alignItems: "start" }}
              >
                <ListItemText
                  primary={`Well: ${
                    record.well?.well_name || record.well_name || "Unknown"
                  }`}
                  secondary={
                    <>
                      <Typography
                        variant="body2"
                        component="span"
                        display="block"
                      >
                        Installed:{" "}
                        {format(
                          new Date(record.installed_at),
                          "MMM dd, yyyy HH:mm"
                        )}
                      </Typography>
                      {record.removed_at && (
                        <Typography
                          variant="body2"
                          component="span"
                          display="block"
                          color="error"
                        >
                          Removed:{" "}
                          {format(
                            new Date(record.removed_at),
                            "MMM dd, yyyy HH:mm"
                          )}
                        </Typography>
                      )}
                      {!record.removed_at && (
                        <Typography
                          variant="body2"
                          component="span"
                          display="block"
                          color="success.main"
                        >
                          Currently Active
                        </Typography>
                      )}
                      {record.installation_note && (
                        <Typography
                          variant="body2"
                          component="span"
                          display="block"
                          sx={{ mt: 1 }}
                        >
                          Notes: {record.installation_note}
                        </Typography>
                      )}
                    </>
                  }
                />
                <Divider sx={{ width: "100%", mt: 2 }} />
              </ListItem>
            ))}
            {(!meterHistory || meterHistory.length === 0) && (
              <Typography variant="body2" color="text.secondary">
                No installation history found
              </Typography>
            )}
          </List>
        )}
      </Box>
    </Drawer>
  );
}
